import { useCurrentProject } from '@adsk/alloy-provider';

import { FLAGS } from './util';
import { usePlangridFeatureFlag } from '../PlangridLaunchDarklyProvider';

export const useIsCurrentUserGalleryAccessLimited = () => {
  const project = useCurrentProject();

  const { value: isGalleryAccessLimited } = usePlangridFeatureFlag(
    FLAGS.PHOTO_GALLERY_ACCESS,
    false,
  );

  return isGalleryAccessLimited && !project?.accessLevels?.projectAdministrator;
};
